import React, { useEffect, useState } from "react";

import DashboardLineChart from "../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

import dayjs from "dayjs";
import { formatDateArrayWithHour } from "../../../utils/DateFormatter";
import DashboardBarChart from "../../CommonComponents/Dashboard/DashboardBarChart/DashboardBarChart";

const CASINO_OPTIONS = {
  "CASINO TURNOVER": "casino_turnover",
  "CASINO GGR": "casino_ggr",
};

function Casino({
  isApiRunning,
  setIsApiRunning,
  turnOverData,
  setTurnOverData,
  ggrData,
  setGgrData,
  isCasinoDataFirstRender,
  casinosSectionDates,
  setCasinosSectionDates,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    true
  );

  const queryString = `start_date=${casinosSectionDates[0].format(
    "YYYY-MM-DD"
  )}&end_date=${casinosSectionDates[1].format("YYYY-MM-DD")}`;

  const [selected, setSelected] = useState("CASINO TURNOVER");

  const casinoData =
    CASINO_OPTIONS[selected] === "casino_turnover" ? turnOverData : ggrData;

  const labels = formatDateArrayWithHour(
    Object.keys(casinoData?.current_data || {})
  );

  const betCoreData = Object.values(casinoData.current_data || {}).map(
    (data) => data.providers.betcore
  );

  const jackTopData = Object.values(casinoData.current_data || {}).map(
    (data) => data.providers.jacktop
  );

  const royalData = Object.values(casinoData.current_data || {}).map(
    (data) => data.providers.royal
  );

  const data2 = {
    labels: labels,
    datasets: [
      {
        data: betCoreData,
        label: "Betcore",
        backgroundColor: ["#6177E8"],
        borderColor: ["#6177E8"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        data: jackTopData,
        label: "Jacktop",
        backgroundColor: ["#71BF8A"],
        borderColor: ["#71BF8A"],
        borderWidth: 1,
        borderRadius: 4,
      },
      {
        data: royalData,
        label: "Royal",
        backgroundColor: ["#F5A623"],
        borderColor: ["#F5A623"],
        borderWidth: 1,
        borderRadius: 4,
      },
    ],
    headers: [
      {
        title: "CASINO TURNOVER",
        amount: turnOverData?.current,
        percentage: turnOverData?.percentage_change,
      },
      {
        title: "CASINO GGR",
        amount: ggrData?.current,
        percentage: ggrData?.percentage_change,
      },
    ],
  };

  const getCasinoData = async (queryString) => {
    setIsApiRunning(true);

    const url = "dashboard/finance/casino-v2?" + queryString;
    try {
      const response = await PrivateAdminPanelInstance?.get(url);
      const data = response?.data.data;

      if (data) {
        const { turnover, ggr } = data;
        setTurnOverData(turnover);

        setGgrData(ggr);
      }
    } catch (error) {
      console.log("error getting casino data", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    if (isCasinoDataFirstRender.current) {
      getCasinoData(queryString);
      isCasinoDataFirstRender.current = false;
    }
  }, []);

  return (
    <DashboardBarChart
      title={false}
      data={data2}
      headers={data2.headers}
      display={true}
      isApiRunning={isApiRunning}
      setSelected={setSelected}
      getData={getCasinoData}
      dates={casinosSectionDates}
      setDates={setCasinosSectionDates}
      showCustomDatePicker={true}
    />
  );
}

export default Casino;
